import { createContext, type ReactNode, useContext } from 'react';
import { useGiayBaoCoExport } from '../hooks';

interface GiayBaoCoContextValue {
  exportToExcel: () => Promise<void>;
  canExport: boolean;
  isExporting: boolean;
}

const GiayBaoCoContext = createContext<GiayBaoCoContextValue | null>(null);

export const useGiayBaoCoContext = () => {
  const context = useContext(GiayBaoCoContext);
  if (!context) {
    throw new Error('useGiayBaoCoContext must be used within GiayBaoCoProvider');
  }
  return context;
};

export const GiayBaoCoProvider = ({ children }: { children: ReactNode }) => {
  const { exportToExcel, canExport, isExporting } = useGiayBaoCoExport();

  return (
    <GiayBaoCoContext.Provider
      value={{
        exportToExcel,
        canExport,
        isExporting
      }}
    >
      {children}
    </GiayBaoCoContext.Provider>
  );
};
